import { z } from 'zod/v4';

import { createEnumSchemaPreprocessor } from '../../../utils/create-enum-schema-preprocessor';

export const ferriesOptions = ['Use', 'Avoid'] as const;

export const ferriesSchema = createEnumSchemaPreprocessor(
  z.enum(ferriesOptions),
  ferriesOptions
);

export type Ferries = z.infer<typeof ferriesSchema>;
